import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const iconButtonVariants = cva(
  "grid size-11 shrink-0 place-items-center rounded-full transition-colors disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        ghost: "text-secondary hover:bg-hover hover:text-foreground",
        secondary:
          "border border-line bg-surface text-foreground hover:border-line-strong hover:bg-hover",
        primary: "bg-primary text-white hover:bg-primary-hover",
      },
    },
    defaultVariants: { variant: "ghost" },
  },
);

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof iconButtonVariants> & { label: string };

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, label, type = "button", variant, ...props }, ref) => (
    <button
      aria-label={label}
      className={cn(iconButtonVariants({ variant }), className)}
      ref={ref}
      type={type}
      {...props}
    />
  ),
);
IconButton.displayName = "IconButton";
